import { useSegmentIdentityTracking } from './hooks/useSegmentIdentityTracking/useSegmentIdentityTracking'
import { useSetFacebookFbcCookie } from './hooks/useSetFacebookFbcCookie/useSetFacebookFbcCookie'
import { useTrackPageViews } from './hooks/useTrackPageViews/useTrackPageViews'

interface SegmentIdentityTrackingProps {
  profileId: string
}
// SegmentIdentityTracking component is a wrapper around the Segment tracking hooks, so they can be used inside AppPage.tsx
// It component should be rendered inside ApolloProvider
export const SegmentIdentityTracking: React.FC<SegmentIdentityTrackingProps> = ({ profileId }) => {
  useSetFacebookFbcCookie()
  useSegmentIdentityTracking(profileId)
  useTrackPageViews()
  return null
}
